import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon, WaitingIcon } from "../index";

const styles = {
	errorPopup: {},
};

const ResultTab = ({ t, disabled, resultStatus }) => {
	return (
		<Popup
			position="bottom right"
			disabled={resultStatus.result !== "" && resultStatus.waiting.length === 0 && !disabled}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="hand point right" size="small" /> {t("subMenu.result")}
					{!disabled && (resultStatus.result && resultStatus.waiting.length === 0 ? <CheckIcon /> : <WaitingIcon />)}
				</span>
			}
		>
			{resultStatus.result && <Popup.Header>{t("subMenu.resultSaved")}</Popup.Header>}
			{resultStatus.waiting !== "" && !resultStatus.result && (
				<>
					<Popup.Header>{t("subMenu.waiting")}</Popup.Header>
					<Popup.Content>
						<List bulleted>
							{resultStatus.waiting.map((waiting, index) => (
								<List.Item key={`results-${index}`}>{waiting}</List.Item>
							))}
						</List>
					</Popup.Content>
				</>
			)}
		</Popup>
	);
};

export default ResultTab;
